<script>
    export let onUpdate = () => {};
    export let liters;

    const options = [1, 30, 40, 50];
</script>

<style>
    .container {
        display: flex;
        margin: var(--margin-small) 0;
    }

    .container button {
        padding: var(--margin-small) var(--margin);
        margin-right: var(--margin);
        border: none;
        border-radius: 4px;
        background-color: var(--color-light-gray);
        color: var(--color-dark);
        font-weight: 500;
        font-family: "E24 Text", sans-serif;
    }

    .container button.active {
        background-color: var(--color-interaction-2);
    }

    .container button:last-child {
        margin-right: 0;
    }

    @media (max-width: 375px) {
        .container button {
            padding: var(--margin-small);
        }
    }

    @media (max-width: 350px) {
        .container button {
            font-size: 12px;
        }
    }

    @media (max-width: 325px) {
        .container button {
            padding: 8px 4px;
        }
    }
</style>

<div class='container'>
    {#each options as value}
        <button on:click={() => onUpdate(value)} class={liters === value ? 'active' : ''}>{value} liter</button>
    {/each}
</div>
